import React, { Component } from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";
import $ from "jquery";

import {toggleBathroomVisualizerOpen, toggleUserPopup} from "../../actions/actionFunctions";
import UserLoginButton from "../ui/userLoginButton";
import {getCurrentCanvas, getCurrentLayout} from "../appLayout";
import HomeButton from "../ui/homeButton";
import MobileMenu from "../ui/mobileMenu";
// import CoBrowsingButton from "../ui/coBrowsingButton";
import ActionTypes from "../../misc/actionTypes"
import PingPilotButton from "../visComponents/pingPilotButton";
import {USE_NEW_CANVAS} from "../../config";

class ShoppingCartCanvas extends Component {

  constructor(props) {
    super(props);
    this.state = {
      layers: []
    }
  }

  componentDidMount() {
    this.setStateLayers();
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.setStateLayers);
  }

  componentWillUnmount() {
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const hasDifference = (nextProps.cartItems.length !== this.props.cartItems.length) || nextProps.cartItems.some((cartItem, index) => {
      return cartItem.cartFeature.dbFeature.id !== this.props.cartItems[index].cartFeature.dbFeature.id
    });
    if (hasDifference) {
      this.setStateLayers();
    }
  }

  setStateLayers = () => {
    const showPlaceHolders = document.bvConfig ? document.bvConfig.showPlaceholders : false;
    const layout = getCurrentLayout();
    this.setState({
      layers: layout.getLayers(showPlaceHolders)
    });
  }

  openVisualizer = () => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    if (fabricatorSettings.leadCaptureShoppingCart && !UserLoginButton.handleLoginClick({...this.props})) {
      return false;
    }
    if (!USE_NEW_CANVAS) { // we don't need it for new smooth open
      this.props.toggleBathroomVisualizerOpen(true);
    }
    hashHistory.push('visualizer');
  };

  render() {
    // console.log('this.props.cartItems', this.props.cartItems);
    const {materialsCanvasClass} = this.props;
    const layout = getCurrentLayout();
    const ImageCanvas = getCurrentCanvas();
    return (
      <div className={"dcart-canvas selection-main__image selection-main__image--" + document.kvConfig.visualizerType
        + " selection-main__image--"+materialsCanvasClass}>
        {this.props.windowWidth < 991 ?
          this.props.mobileNav && this.props.mobileNav.length > 0
            ? <MobileMenu smallButton={true}
                          smallButtonClassName={"scart-canvas__button scart-canvas__button--home"}/>
            : <HomeButton className="scart-canvas__button scart-canvas__button--home" />
          : null}
        <ImageCanvas canvasId="shoppingCartDesktopCanvas"
                     layers={this.state.layers}
                     width={this.props.canvasDimensions.width}
                     height={this.props.canvasDimensions.height}
                     layoutType={layout.getCurrentLayoutName()}
                     layout={layout}
                     useMouseHovering={false}
        />
        <button className="selection-main__image-button selection-main__image-button--fullscreen"
                onClick={this.openVisualizer}/>
        {/*{this.props.fabricatorData.isAmericanImport ? <CoBrowsingButton/> : null}*/}
        <PingPilotButton/>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {materialsCanvasClass} = store.selectionState;
  return {
    cartItems: store.cartState.cartItems,
    fabricatorData: store.fabricatorState,
    windowWidth: store.serverState.windowWidth,
    mobileNav: store.navigationState.mobileNav,
    canvasDimensions: store.bathroomVisualizerState.canvasDimensions,
    materialsCanvasClass,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  toggleUserPopup
})(ShoppingCartCanvas);
